import { QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, redirect, RouterProvider } from "react-router";
import { Toaster } from "sonner";

import AttendancePage from "safety/pages/AttendancePage";
import MeetingCodeEntryPage from "safety/pages/MeetingCodeEntryPage";
import PassportPage from "safety/pages/PassportPage";
import RedirectToMarketing from "safety/pages/RedirectToMarketing";
import { SafetyProfilePage } from "safety/pages/SafetyProfilePage";
import SdsPage from "safety/pages/SdsPage";
import { queryClient } from "safety/queryClient";

/*
 * Token routes render public safety resources. Every other path bounces to the
 * marketing site so the bare domain is safe if someone hits it directly.
 */
const router = createBrowserRouter([
  {
    path: "/passport/:token",
    element: (
      <>
        <title>Miter Safety Passport</title>
        <PassportPage />
      </>
    ),
  },
  {
    path: "/sds/:token",
    element: (
      <>
        <title>Miter Safety Data Sheet</title>
        <SdsPage />
      </>
    ),
  },
  {
    path: "/profile/:slug",
    element: <SafetyProfilePage />,
  },
  {
    path: "/meeting",
    element: (
      <>
        <title>Miter Safety Meeting Sign-In</title>
        <MeetingCodeEntryPage />
      </>
    ),
  },
  {
    path: "/m/:code",
    loader: ({ params }) => redirect(`/meeting/${params.code}`),
  },
  {
    path: "/meeting/:code",
    element: (
      <>
        <title>Miter Safety Meeting Sign-In</title>
        <AttendancePage />
      </>
    ),
  },
  { path: "*", element: <RedirectToMarketing /> },
]);

const App = (): React.JSX.Element => {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="bottom-center" duration={2000} />
    </QueryClientProvider>
  );
};

export default App;
